import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../CookieConsent/CookieConsent.scss";

const CookieConsent = () => {
  const [CookieVisible, setCookieVisible] = useState(false);

  // useEffect(() => {
  //   // ✅ 1. Simple Cookiebot visibility poller
  //   const intervalId = setInterval(() => {
  //     if (typeof window !== "undefined" && window.cookieconsent && !CookieVisible) {
  //       setCookieVisible(true);
  //     }
  //   }, 300);

  //   // ✅ 2. Function to toggle body overlay class
  //   const cookieBotChecker = () => {
  //     const dialogActive = document.querySelectorAll(".CybotCookiebotDialogActive").length > 0;
  //     const bodyHasClass = document.body.classList.contains("cookieBotActive");

  //     if (dialogActive && !bodyHasClass) {
  //       document.body.classList.add("cookieBotActive");
  //     } else if (!dialogActive && bodyHasClass) {
  //       document.body.classList.remove("cookieBotActive");
  //     }
  //   };

  //   // ✅ 3. Run the check periodically to ensure static-safe detection
  //   const observer = setInterval(cookieBotChecker, 100);

  //   return () => {
  //     clearInterval(intervalId);
  //     clearInterval(observer);
  //   };
  // }, [CookieVisible]);

useEffect(() => {
  if (typeof window === "undefined") return;

  const showOverlay = () => document.body.classList.add("cookieBotActive");
  const hideOverlay = () => document.body.classList.remove("cookieBotActive");

  const isDialogVisible = () => {
    const el = document.querySelector("#CybotCookiebotDialog");
    if (!el) return false;

    const style = window.getComputedStyle(el);

    const hidden =
      style.display === "none" ||
      style.visibility === "hidden" ||
      style.opacity === "0";

    return !hidden;
  };

  const checkVisibility = () => {
    isDialogVisible() ? showOverlay() : hideOverlay();
  };

  // Cookiebot events
  window.addEventListener("CookiebotOnDialogDisplay", showOverlay);
  window.addEventListener("CookiebotOnDialogHide", hideOverlay);
  window.addEventListener("CookiebotOnAccept", hideOverlay);
  window.addEventListener("CookiebotOnDecline", hideOverlay);

  // Observe DOM changes (for async loading)
  const observer = new MutationObserver(checkVisibility);
  observer.observe(document.body, { childList: true, subtree: true });

  // Run once on load
  setTimeout(checkVisibility, 300);

  return () => {
    window.removeEventListener("CookiebotOnDialogDisplay", showOverlay);
    window.removeEventListener("CookiebotOnDialogHide", hideOverlay);
    window.removeEventListener("CookiebotOnAccept", hideOverlay);
    window.removeEventListener("CookiebotOnDecline", hideOverlay);
    observer.disconnect();
  };
}, []);



  return (
    <React.Fragment>
      <Helmet>
        {/* --- Google & tracking scripts --- */}
        <script
          type="text/plain"
          data-cookie-consent="tracking"
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-QR18MLXJXS&l=dataLayer&cx=c"
        ></script>
        <script
          type="text/plain"
          data-cookie-consent="tracking"
          async
          src="https://www.google-analytics.com/analytics.js"
        ></script>
        <script
          type="text/plain"
          data-cookie-consent="tracking"
          src="https://www.googletagmanager.com/gtm.js?id=GTM-PFQWTQ7"
        ></script>

        <script type="text/plain" data-cookie-consent="tracking">{`
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ platform: "gatsby" });
          (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, "script", "dataLayer", "GTM-PFQWTQ7");
        `}</script>

        <script
          type="text/plain"
          data-cookie-consent="tracking"
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-746919213"
        ></script>
        <script type="text/plain" data-cookie-consent="tracking">{`
          window.dataLayer = window.dataLayer || [];
          function gtag() { dataLayer.push(arguments); }
          gtag("js", new Date());
          gtag("config", "AW-746919213");
        `}</script>

        <script
          type="text/plain"
          data-cookie-consent="tracking"
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-17360142381"
        ></script>
        <script type="text/plain" data-cookie-consent="tracking">{`
          window.dataLayer = window.dataLayer || [];
          function gtag() { dataLayer.push(arguments); }
          gtag("js", new Date());
          gtag("config", "AW-17360142381");
        `}</script>

        {/* --- Consent defaults --- */}
        <script data-cookieconsent="ignore">{`
          window.dataLayer = window.dataLayer || [];
          function gtag() { dataLayer.push(arguments); }
          gtag("consent", "default", {
            ad_storage: "granted",
            analytics_storage: "granted",
            ad_user_data: "denied",
            ad_personalization: "denied",
            functionality_storage: "denied",
            personalization_storage: "denied",
            security_storage: "granted",
            wait_for_update: 500
          });
          gtag("set", "ads_data_redaction", true);
          gtag("set", "url_passthrough", false);
        `}</script>

        {/* --- Google Analytics 4 --- */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-QR18MLXJXS"></script>
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-QR18MLXJXS');
        `}</script>

        {/* --- Cookiebot CMP --- */}
        <script
          key="cookiebot"
          id="Cookiebot"
          src="https://consent.cookiebot.com/uc.js"
          data-blockingmode="auto"
          data-cbid="5c7e8226-9280-49a6-a00f-59de94dd9a03"
          data-framework="GTM"
          type="text/javascript"
          async
        />
      </Helmet>
    </React.Fragment>
  );
};

export default CookieConsent;
